import React from "react";
import {useKensuAuth} from "../Util/AuthWrapper";

interface Props {
}

export const Header = (props: Props) => {

  const {user, logout} = useKensuAuth();
  const host = window.location.host

  return (
      <div className={'Header'}>
        <div className={'HeaderLeftElement'}>
          kensu&nbsp;
          {host.startsWith("localhost") && <span style={{color:'blue'}}>local&nbsp;</span>}
          {host.endsWith("thymebook.com") && <span style={{color:'green'}}>dev&nbsp;</span>}
          {(host.endsWith("onkensu.com") || host.endsWith("kensu-admin-fj315.web.app")) && 
              <span style={{color:'red'}}>production&nbsp;</span>}
          admin 
        </div>
        <div className={'HeaderRightElement'}>
          {user && <>
            <strong>{user?.email}</strong> |
            <button onClick={(() => logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            }))}>logout
            </button>
          </>}
        </div>

      </div>
  );
} 
